export default class CommandeApiDriveService {
  path = "/api/me/commandes";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des commandes du client connecté
   */
  async commandes(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(this.path, config);
    return res.data;
  }

  /**
   * Détail d'une commande du client connecté
   * @param {String} id
   */
  async commande(id, params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/${id}`, config);
    return res.data;
  }

  /**
   * Update d'une commande du client connecté
   * @param {String} id
   * @param {Object} data
   */
  async update(id, data) {
    const res = await this.httpApi.put(`${this.path}/${id}`, data);
    return res.data;
  }

  /**
   * Update d'une commande du client connecté
   * @param {String} id
   * @param {Object} data
   */
  async generateFacture(id, data) {
    const res = await this.httpApi.post(`${this.path}/${id}/facture`, data);
    return res.data;
  }
}
